export default __webpack_public_path__ + "static/media/code1.31a11218.jpg";